define('OutSystems/ClientRuntime/modules/Database/Common/EntityModelUtils',["require", "exports", "tslib", "../../../DataConversion", "../../../DataTypes", "../../../Exceptions", "../../../Logger", "../AutoNumber", "../DatabaseTypeUtils", "../DBDataType", "../Metadata/EntityUpgradeStatus", "../Metadata/MetadataBackupTableInfo", "../Metadata/MetadataTableInfo", "../TableInfoUtils", "./ValueConstraintValidation"], function (require, exports, tslib_1, DataConversion_1, DataTypes_1, Exceptions_1, Logger, AutoNumber_1, DatabaseTypeUtils_1, DBDataType_1, EntityUpgradeStatus_1, MetadataBackupTableInfo_1, MetadataTableInfo_1, TableInfoUtils, ValueConstraintValidation_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.recreateTable = exports.backupDeletedTables = exports.dropBackupTables = exports.dropInconsistentTables = exports.recoverBackupTables = exports.createOrUpgradeTable = exports.loadStoredMetadata = exports.getFirstItem = void 0;
    function trace(message) {
        Logger.trace("EntityModelUtils", message);
    }
    function getFirstItem(array) {
        return array[0];
    }
    exports.getFirstItem = getFirstItem;
    function loadStoredMetadata(transaction, moduleKey) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var metadata;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, transaction.findRecords(MetadataTableInfo_1.default, { MODULEKEY: moduleKey })];
                    case 1:
                        metadata = _a.sent();
                        return [2, metadata];
                }
            });
        });
    }
    exports.loadStoredMetadata = loadStoredMetadata;
    function createOrUpgradeTable(transaction, info, metadata, serializer) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var hash, extraInfo;
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        trace("Checking the status of table ".concat(info.tableName, " (").concat(info.name, ")"));
                        extraInfo = {};
                        if (metadata) {
                            hash = metadata.HASH;
                            extraInfo = JSON.parse((_a = metadata.EXTRAINFO) !== null && _a !== void 0 ? _a : "{}");
                        }
                        if (!!hash) return [3, 3];
                        trace("Table ".concat(info.tableName, " (").concat(info.name, ") does not exist and will be created"));
                        return [4, createTable(transaction, info, serializer)];
                    case 1:
                        _b.sent();
                        return [4, insertTableMetadata(transaction, info)];
                    case 2:
                        _b.sent();
                        return [3, 4];
                    case 3:
                        if (hash !== info.hash) {
                            if (requiresFullUpgrade(info, extraInfo)) {
                                trace("Table ".concat(info.tableName, " (").concat(info.name, ") exists and will be fully upgraded"));
                                return [2, recreateTable(transaction, info, extraInfo, serializer)];
                            }
                            else {
                                trace("Table ".concat(info.tableName, " (").concat(info.name, ") exists and will be incrementally upgraded"));
                                return [2, upgradeTable(transaction, info, extraInfo, serializer)];
                            }
                        }
                        else {
                            trace("Table ".concat(info.tableName, " (").concat(info.name, ") exists and is up to date"));
                        }
                        _b.label = 4;
                    case 4: return [2];
                }
            });
        });
    }
    exports.createOrUpgradeTable = createOrUpgradeTable;
    function recoverBackupTables(transaction, entityInfos, moduleKey) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2, doForEachTable(transaction, function (tableName) {
                        trace("Recovering table ".concat(tableName, " from backup"));
                        var filtered = entityInfos.filter(function (value) { return value.tableName === tableName; });
                        return function (transaction) {
                            return recoverBackupTable(transaction, tableName, filtered.length === 1 ? filtered[0] : null, moduleKey);
                        };
                    }, moduleKey, function (record) { return record.UPGRADESTATUS !== EntityUpgradeStatus_1.default.Unchanged; })];
            });
        });
    }
    exports.recoverBackupTables = recoverBackupTables;
    function recoverBackupTable(transaction, tableName, info, moduleKey) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var hasBackupTable;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, dropTableIfExists(transaction, tableName)];
                    case 1:
                        _a.sent();
                        return [4, transaction.existsTable(getBackupTableName(tableName))];
                    case 2:
                        hasBackupTable = _a.sent();
                        if (!hasBackupTable) return [3, 4];
                        return [4, renameTableAndSetStatus(transaction, getBackupTableName(tableName), tableName, tableName, EntityUpgradeStatus_1.default.Unchanged)];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4: return [4, copyMetadata(transaction, tableName, true)];
                    case 5:
                        _a.sent();
                        return [2];
                }
            });
        });
    }
    function dropInconsistentTables(transaction, entityInfos, moduleKey) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2, doForEachTable(transaction, function (tableName) {
                        trace("Dropping inconsistent table ".concat(tableName, " (same key, different physical table name)"));
                        return function (transaction) { return dropInconsistentTable(transaction, tableName); };
                    }, moduleKey, function (record) {
                        var isUnchanged = record.UPGRADESTATUS === EntityUpgradeStatus_1.default.Unchanged;
                        var keyExists = entityInfos.some(function (info) { return info.key === record.KEY; });
                        var tableNameNotExists = !entityInfos.some(function (info) { return info.tableName === record.TABLENAME; });
                        var inconsistentOnEntityInfos = entityInfos.length === 0 ? true : keyExists && tableNameNotExists;
                        return isUnchanged && inconsistentOnEntityInfos;
                    })];
            });
        });
    }
    exports.dropInconsistentTables = dropInconsistentTables;
    function dropInconsistentTable(transaction, tableName) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var inconsistentMetadataRecord, _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4, dropTableIfExists(transaction, tableName)];
                    case 1:
                        _b.sent();
                        _a = getFirstItem;
                        return [4, transaction.findRecords(MetadataTableInfo_1.default, { TABLENAME: tableName })];
                    case 2:
                        inconsistentMetadataRecord = _a.apply(void 0, [_b.sent()]);
                        if (!inconsistentMetadataRecord) return [3, 4];
                        return [4, transaction.removeRecord(MetadataTableInfo_1.default, [
                                inconsistentMetadataRecord.KEY,
                                inconsistentMetadataRecord.MODULEKEY,
                            ])];
                    case 3:
                        _b.sent();
                        _b.label = 4;
                    case 4: return [2];
                }
            });
        });
    }
    function dropBackupTables(transaction, moduleKey) {
        return doForEachTable(transaction, function (tableName) {
            trace("Dropping backup table for ".concat(tableName));
            return function (transaction) { return dropBackupTable(transaction, tableName); };
        }, moduleKey, function (record) { return record.UPGRADESTATUS !== EntityUpgradeStatus_1.default.Unchanged; });
    }
    exports.dropBackupTables = dropBackupTables;
    function backupDeletedTables(transaction, entityInfos, moduleKey) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2, doForEachTable(transaction, function (tableName) {
                        trace("Backing up table ".concat(tableName, " before deletion"));
                        return function (transaction) { return backupTable(transaction, tableName, EntityUpgradeStatus_1.default.Deleted); };
                    }, moduleKey, function (record) {
                        return record.UPGRADESTATUS === EntityUpgradeStatus_1.default.Unchanged &&
                            !entityInfos.some(function (info) { return info.tableName === record.TABLENAME; });
                    })];
            });
        });
    }
    exports.backupDeletedTables = backupDeletedTables;
    function doForEachTable(transaction, action, moduleKey, criteria) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var allModuleTables, desiredTables, _i, allModuleTables_1, table, _a, desiredTables_1, table;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4, transaction.findRecords(MetadataTableInfo_1.default, { MODULEKEY: moduleKey })];
                    case 1:
                        allModuleTables = (_b.sent());
                        desiredTables = [];
                        if (criteria) {
                            for (_i = 0, allModuleTables_1 = allModuleTables; _i < allModuleTables_1.length; _i++) {
                                table = allModuleTables_1[_i];
                                if (criteria(table)) {
                                    desiredTables.push(table);
                                }
                            }
                        }
                        else {
                            desiredTables = allModuleTables;
                        }
                        _a = 0, desiredTables_1 = desiredTables;
                        _b.label = 2;
                    case 2:
                        if (!(_a < desiredTables_1.length)) return [3, 5];
                        table = desiredTables_1[_a];
                        return [4, action(table.TABLENAME)(transaction)];
                    case 3:
                        _b.sent();
                        _b.label = 4;
                    case 4:
                        _a++;
                        return [3, 2];
                    case 5: return [2];
                }
            });
        });
    }
    function backupTable(transaction, tableName, reason) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        trace("Backing up table '".concat(tableName, "'"));
                        return [4, copyMetadata(transaction, tableName, false)];
                    case 1:
                        _a.sent();
                        return [4, dropTableIfExists(transaction, getBackupTableName(tableName))];
                    case 2:
                        _a.sent();
                        return [2, renameTableAndSetStatus(transaction, tableName, getBackupTableName(tableName), tableName, reason)];
                }
            });
        });
    }
    function dropTableIfExists(transaction, tableName) {
        return transaction.deleteTableIfExists(tableName);
    }
    function dropBackupTable(transaction, tableName) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var metadata, _a, backupMetadata, _b;
            return tslib_1.__generator(this, function (_c) {
                switch (_c.label) {
                    case 0: return [4, dropTableIfExists(transaction, getBackupTableName(tableName))];
                    case 1:
                        _c.sent();
                        _a = getFirstItem;
                        return [4, transaction.findRecords(MetadataTableInfo_1.default, { TABLENAME: tableName })];
                    case 2:
                        metadata = _a.apply(void 0, [_c.sent()]);
                        if (!metadata) return [3, 6];
                        if (!(metadata.UPGRADESTATUS === EntityUpgradeStatus_1.default.Deleted)) return [3, 4];
                        return [4, transaction.removeRecord(MetadataTableInfo_1.default, [metadata.KEY, metadata.MODULEKEY])];
                    case 3:
                        _c.sent();
                        return [3, 6];
                    case 4:
                        metadata.UPGRADESTATUS = EntityUpgradeStatus_1.default.Unchanged;
                        return [4, transaction.updateRecord(MetadataTableInfo_1.default, metadata)];
                    case 5:
                        _c.sent();
                        _c.label = 6;
                    case 6:
                        _b = getFirstItem;
                        return [4, transaction.findRecords(MetadataBackupTableInfo_1.default, { TABLENAME: tableName })];
                    case 7:
                        backupMetadata = _b.apply(void 0, [_c.sent()]);
                        if (!backupMetadata) return [3, 9];
                        return [4, transaction.removeRecord(MetadataBackupTableInfo_1.default, [backupMetadata.KEY, backupMetadata.MODULEKEY])];
                    case 8:
                        _c.sent();
                        _c.label = 9;
                    case 9: return [2];
                }
            });
        });
    }
    function renameTableAndSetStatus(transaction, currentTableName, newTableName, originalTableName, upgradeStatus) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        trace("Renaming table '".concat(currentTableName, "' to '").concat(newTableName, "' and setting status to ").concat(EntityUpgradeStatus_1.default[upgradeStatus]));
                        return [4, renameTable(transaction, currentTableName, newTableName)];
                    case 1:
                        _a.sent();
                        return [2, setTableUpgradeStatus(transaction, originalTableName, upgradeStatus)];
                }
            });
        });
    }
    function renameTable(transaction, currentTableName, newTableName) {
        return transaction.renameTable(currentTableName, newTableName);
    }
    function setTableUpgradeStatus(transaction, tableName, upgradeStatus) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var metadata, _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = getFirstItem;
                        return [4, transaction.findRecords(MetadataTableInfo_1.default, { TABLENAME: tableName })];
                    case 1:
                        metadata = _a.apply(void 0, [_b.sent()]);
                        metadata.UPGRADESTATUS = upgradeStatus;
                        return [2, transaction.updateRecord(MetadataTableInfo_1.default, metadata)];
                }
            });
        });
    }
    function getBackupTableName(tableName) {
        return "".concat(TableInfoUtils.BACKUP_TABLE_PREFIX).concat(tableName);
    }
    function createTable(transaction, info, serializer) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                trace("Creating table ".concat(info.tableName, " (").concat(info.name, ")"));
                return [2, transaction.createTable(tslib_1.__assign(tslib_1.__assign({}, info), { attributes: tslib_1.__spreadArray([], info.attributes.map(function (attribute) {
                            var _a;
                            return tslib_1.__assign(tslib_1.__assign({}, attribute), { serializedDefault: serializer.serialize((_a = attribute.default) !== null && _a !== void 0 ? _a : (0, DatabaseTypeUtils_1.typeDefaultValue)(attribute.type), attribute) });
                        }), true) }))];
            });
        });
    }
    function insertTableMetadata(transaction, info) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var metadataRecord;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        metadataRecord = makeMetadataRecord(info);
                        metadataRecord.UPGRADESTATUS = EntityUpgradeStatus_1.default.New;
                        trace("Creating metadata for table ".concat(info.tableName, " (").concat(info.name, ")"));
                        return [4, transaction.insertRecord(MetadataTableInfo_1.default, metadataRecord)];
                    case 1:
                        _a.sent();
                        return [2];
                }
            });
        });
    }
    function updateTableMetadata(transaction, info) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var currentMetadata, metadataRecord;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        trace("Updating metadata for table ".concat(info.tableName, " (").concat(info.name, ")"));
                        return [4, transaction.getRecord(MetadataTableInfo_1.default, [
                                info.key,
                                info.moduleKey,
                            ])];
                    case 1:
                        currentMetadata = (_a.sent());
                        metadataRecord = makeMetadataRecord(info);
                        metadataRecord.UPGRADESTATUS = currentMetadata.UPGRADESTATUS;
                        metadataRecord.LASTIDENTIFIER = currentMetadata.LASTIDENTIFIER;
                        return [4, transaction.updateRecord(MetadataTableInfo_1.default, metadataRecord)];
                    case 2:
                        _a.sent();
                        return [2];
                }
            });
        });
    }
    function recreateTable(transaction, info, metadata, serializer) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var dbRecords, _i, dbRecords_1, dbRecord, newDbRecord, error_1, errorMessage;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 9, , 10]);
                        return [4, transaction.getAllRecords(info)];
                    case 1:
                        dbRecords = _a.sent();
                        return [4, backupTable(transaction, info.tableName, EntityUpgradeStatus_1.default.Recreated)];
                    case 2:
                        _a.sent();
                        return [4, createTable(transaction, info, serializer)];
                    case 3:
                        _a.sent();
                        _i = 0, dbRecords_1 = dbRecords;
                        _a.label = 4;
                    case 4:
                        if (!(_i < dbRecords_1.length)) return [3, 7];
                        dbRecord = dbRecords_1[_i];
                        newDbRecord = upgradeDbRecord(dbRecord, info, metadata, serializer);
                        return [4, transaction.insertRecord(info, newDbRecord)];
                    case 5:
                        _a.sent();
                        _a.label = 6;
                    case 6:
                        _i++;
                        return [3, 4];
                    case 7: return [4, updateTableMetadata(transaction, info)];
                    case 8:
                        _a.sent();
                        return [3, 10];
                    case 9:
                        error_1 = _a.sent();
                        errorMessage = "Unable to upgrade the definition of entity '".concat(info.name, "':\n").concat((0, Exceptions_1.getMessage)(error_1));
                        trace(errorMessage);
                        throw new Exceptions_1.Exceptions.DataBaseException("", errorMessage);
                    case 10: return [2];
                }
            });
        });
    }
    exports.recreateTable = recreateTable;
    function upgradeTable(transaction, info, metadataExtraInfo, serializer) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var newAttributes, _i, newAttributes_1, attribute, serializedDefault;
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        newAttributes = info.attributes.filter(function (attr) {
                            return !Object.keys(metadataExtraInfo.attrs).some(function (metadataAttrName) { return metadataAttrName === attr.columnName; });
                        });
                        trace("Upgrading table ".concat(info.tableName, " (").concat(info.name, ") with new attributes (").concat((function () {
                            return JSON.stringify(newAttributes);
                        })(), ") and new hash (").concat(info.hash, ")"));
                        _i = 0, newAttributes_1 = newAttributes;
                        _b.label = 1;
                    case 1:
                        if (!(_i < newAttributes_1.length)) return [3, 4];
                        attribute = newAttributes_1[_i];
                        serializedDefault = serializer.serialize((_a = attribute.default) !== null && _a !== void 0 ? _a : (0, DatabaseTypeUtils_1.typeDefaultValue)(attribute.type), attribute);
                        return [4, transaction.addColumn(info, tslib_1.__assign(tslib_1.__assign({}, attribute), { serializedDefault: serializedDefault }))];
                    case 2:
                        _b.sent();
                        _b.label = 3;
                    case 3:
                        _i++;
                        return [3, 1];
                    case 4: return [4, updateTableMetadata(transaction, info)];
                    case 5:
                        _b.sent();
                        return [2];
                }
            });
        });
    }
    function upgradeDbRecord(dbRecord, info, extraInfo, serializer) {
        var newDbRecord = {};
        for (var _i = 0, _a = info.attributes; _i < _a.length; _i++) {
            var attr = _a[_i];
            try {
                var attrName = attr.columnName;
                var oldValue = dbRecord[attrName];
                newDbRecord[attrName] = convertRecordAttribute(oldValue, attr, extraInfo, serializer);
            }
            catch (error) {
                throw new Exceptions_1.Exceptions.DataBaseException("", "Unable to upgrade attribute '".concat(attr.name, "' data type to '").concat((0, DatabaseTypeUtils_1.typeDisplayName)(attr.type), "':\n").concat((0, Exceptions_1.getMessage)(error)));
            }
        }
        fillWithDefaults(newDbRecord, info, serializer);
        return newDbRecord;
    }
    function fillWithDefaults(dbRecord, info, serializer) {
        for (var _i = 0, _a = info.attributes; _i < _a.length; _i++) {
            var expectedAttr = _a[_i];
            var attrName = expectedAttr.columnName;
            if (dbRecord[attrName] === undefined) {
                var defaultValue = expectedAttr.default === undefined ? (0, DatabaseTypeUtils_1.typeDefaultValue)(expectedAttr.type) : expectedAttr.default;
                dbRecord[attrName] = serializer.serialize(defaultValue, expectedAttr);
            }
        }
    }
    function convertRecordAttribute(attrValue, attr, extraInfo, serializer) {
        var extraInfoAttr = extraInfo.attrs[attr.columnName];
        if (extraInfoAttr) {
            return upgradeDbValue(attrValue, extraInfoAttr, attr, serializer);
        }
        return attrValue;
    }
    function upgradeDbValue(dbValue, fromInfo, toInfo, serializer) {
        if (serializer.isConversionNeeded(fromInfo, toInfo)) {
            var originalValue = serializer.deserialize(dbValue, fromInfo);
            var newModelDataType = (0, DatabaseTypeUtils_1.convertToModelDataType)(toInfo.type);
            var operation = createOperationLabel(fromInfo, toInfo);
            if (DataConversion_1.JSConversions.isConvertibleTo(originalValue, newModelDataType)) {
                var convertedValue = DataConversion_1.JSConversions.convertTo(originalValue, newModelDataType);
                (0, ValueConstraintValidation_1.validateValueForCreateOrUpdate)(convertedValue, toInfo, operation);
                var dbConvertedValue = serializer.serialize(convertedValue, toInfo);
                return dbConvertedValue;
            }
            else {
                throw new Exceptions_1.Exceptions.DataBaseException("", "Unable to ".concat(operation, "."));
            }
        }
        else {
            return dbValue;
        }
    }
    function createOperationLabel(fromInfo, toInfo) {
        var fromTypeLabel = DataTypes_1.DataTypes[(0, DatabaseTypeUtils_1.convertToModelDataType)(fromInfo.type)];
        var toTypeLabel = DataTypes_1.DataTypes[(0, DatabaseTypeUtils_1.convertToModelDataType)(toInfo.type)];
        return "convert column '".concat(toInfo.name, "' from type ").concat(fromTypeLabel, " to ").concat(toTypeLabel);
    }
    function requiresFullUpgrade(info, metadata) {
        if (metadata.idIsAutoNumber !== info.idIsAutoNumber) {
            return true;
        }
        var attrInfos = getAttributeInfoSummary(info, metadata);
        return attrInfos.some(function (attrInfo) {
            if (!attrInfo.entityAttr) {
                return true;
            }
            if (!attrInfo.metadataAttr) {
                return attrInfo.entityAttr.isPrimaryKey;
            }
            return columnDefinitionHasChanged(attrInfo.entityAttr, attrInfo.metadataAttr);
        });
    }
    function getAttributeInfoSummary(info, metadata) {
        var pairedInfo = {};
        for (var _i = 0, _a = info.attributes; _i < _a.length; _i++) {
            var einfoAttr = _a[_i];
            var attrName = einfoAttr.columnName;
            pairedInfo[attrName] = {};
            pairedInfo[attrName].entityAttr = einfoAttr;
        }
        for (var _b = 0, _c = Object.keys(metadata.attrs); _b < _c.length; _b++) {
            var attr = _c[_b];
            pairedInfo[attr] = pairedInfo[attr] || {};
            pairedInfo[attr].metadataAttr = metadata.attrs[attr];
        }
        return Object.keys(pairedInfo).map(function (attrName) { return pairedInfo[attrName]; });
    }
    function columnDefinitionHasChanged(info, metadata) {
        return typeDefinitionHasChanged(info, metadata) || !metadata.isPrimaryKey !== !info.isPrimaryKey;
    }
    function typeDefinitionHasChanged(info, metadata) {
        return (info.type !== metadata.type ||
            metadata.length !== info.length ||
            metadata.decimals !== info.decimals ||
            (!!metadata.isEntityReference !== !!info.isEntityReference && !info.isPrimaryKey));
    }
    function copyMetadata(transaction, tableName, isRollback) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var sourceTable, targetTable, oldTargetToDelete, _a, sourceToBackup, _b, newSourceToDelete, _c;
            return tslib_1.__generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        sourceTable = isRollback ? MetadataBackupTableInfo_1.default : MetadataTableInfo_1.default;
                        targetTable = isRollback ? MetadataTableInfo_1.default : MetadataBackupTableInfo_1.default;
                        _a = getFirstItem;
                        return [4, transaction.findRecords(targetTable, { TABLENAME: tableName })];
                    case 1:
                        oldTargetToDelete = _a.apply(void 0, [_d.sent()]);
                        if (!oldTargetToDelete) return [3, 3];
                        return [4, transaction.removeRecord(targetTable, [oldTargetToDelete.KEY, oldTargetToDelete.MODULEKEY])];
                    case 2:
                        _d.sent();
                        _d.label = 3;
                    case 3:
                        _b = getFirstItem;
                        return [4, transaction.findRecords(sourceTable, { TABLENAME: tableName })];
                    case 4:
                        sourceToBackup = _b.apply(void 0, [_d.sent()]);
                        if (!sourceToBackup) return [3, 6];
                        return [4, transaction.insertRecord(targetTable, sourceToBackup)];
                    case 5:
                        _d.sent();
                        _d.label = 6;
                    case 6:
                        if (!isRollback) return [3, 9];
                        _c = getFirstItem;
                        return [4, transaction.findRecords(sourceTable, { TABLENAME: tableName })];
                    case 7:
                        newSourceToDelete = _c.apply(void 0, [_d.sent()]);
                        if (!newSourceToDelete) return [3, 9];
                        return [4, transaction.removeRecord(sourceTable, [newSourceToDelete.KEY, newSourceToDelete.MODULEKEY])];
                    case 8:
                        _d.sent();
                        _d.label = 9;
                    case 9: return [2];
                }
            });
        });
    }
    function makeMetadataRecord(entityInfo) {
        var extraInfoMetadata = makeExtraInfoMetadata(entityInfo);
        var identifierColumn = TableInfoUtils.getIdentifierColumn(entityInfo);
        var autoNumberDefault = (identifierColumn === null || identifierColumn === void 0 ? void 0 : identifierColumn.type) === DBDataType_1.default.INTEGER ? 0 : "0";
        return {
            KEY: entityInfo.key,
            MODULEKEY: entityInfo.moduleKey,
            UPGRADESTATUS: EntityUpgradeStatus_1.default.Unchanged,
            NAME: entityInfo.name,
            TABLENAME: entityInfo.tableName,
            HASH: entityInfo.hash,
            LASTIDENTIFIER: identifierColumn && entityInfo.idIsAutoNumber !== AutoNumber_1.default.No ? autoNumberDefault : undefined,
            EXTRAINFO: JSON.stringify(extraInfoMetadata),
        };
    }
    function makeExtraInfoMetadata(entityInfo) {
        var attributesMetadataRecord = {};
        entityInfo.attributes.map(function (attr) {
            attributesMetadataRecord[attr.columnName] = {
                type: attr.type,
                isPrimaryKey: attr.isPrimaryKey,
                length: attr.length,
                decimals: attr.decimals,
                isEntityReference: attr.isEntityReference,
            };
        });
        return {
            v: 2,
            idIsAutoNumber: entityInfo.idIsAutoNumber,
            attrs: attributesMetadataRecord,
        };
    }
});
//# sourceMappingURL=EntityModelUtils.js.map;
